import { useSearchParams } from "react-router-dom";

export const AuditFilterType = {
    UserId: 'user_id',
    Search: 'search',
    Page: 'page',
    PageSize: 'page_size',
    ClientId: 'client_id',
} as const;

export type AuditFilterType = typeof AuditFilterType[keyof typeof AuditFilterType];


export default function useGetAuditsFiltersQuery() {
    const [searchParams] = useSearchParams();

    const userIdQuery = searchParams.get(AuditFilterType.UserId);
    const searchQuery = searchParams.get(AuditFilterType.Search);
    const pageQuery = searchParams.get(AuditFilterType.Page);
    const pageSizeQuery = searchParams.get(AuditFilterType.PageSize);
    const clientIdQuery = searchParams.get(AuditFilterType.ClientId);

    return {
        userIdQuery,
        pageSizeQuery,
        pageQuery,
        searchQuery,
        clientIdQuery,
    };
}
